import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";
import { Backdrop, Box, CircularProgress } from '@mui/material';
import Navbar from '../panel/Navbar';
import Footbar from '../panel/Footbar';
import { useAppContext } from "../config/context";

const Reminder = lazy(() => import("./Reminder"));
const Todo = lazy(() => import("./Todo"));
const Kanban = lazy(() => import("./Kanban"));
const FireKanban = lazy(() => import("./FireKanban"));
const Note = lazy(() => import("./Note"));
const Link = lazy(() => import("./Link"));
const Log = lazy(() => import("./Log"));
const Instruction = lazy(() => import("./Instruction"));

const BackDrop = () => {
  return (
    <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
    </Backdrop>
  )
}
export default function App() {
  const { PLATFORM } = useAppContext();
  return (
    <Router>
      <Navbar />
      <Box sx={{ minHeight: '75vh' }}>
        <Routes>
          <Route index element={<Suspense fallback={<BackDrop />}><Todo /></Suspense>} />
          <Route path="/" exact element={<Suspense fallback={<BackDrop />}><Todo /></Suspense>} />
          <Route path="/reminders" element={<Suspense fallback={<BackDrop />}><Reminder /></Suspense>} />
          <Route path="/notes" element={<Suspense fallback={<BackDrop />}><Note /></Suspense>} />
          {
            PLATFORM === "backend" ?
            <Route path="/kanban" exact element={<Suspense fallback={<BackDrop />}><Kanban /></Suspense>} /> :
            <Route path="/kanban" exact element={<Suspense fallback={<BackDrop />}><FireKanban /></Suspense>} />
          }
          <Route path="/links" element={<Suspense fallback={<BackDrop />}><Link /></Suspense>} />
          <Route path="/logs" element={<Suspense fallback={<BackDrop />}><Log /></Suspense>} />
          <Route path="/instructions" element={<Suspense fallback={<BackDrop />}><Instruction /></Suspense>} />
        </Routes>
      </Box>
      <Box sx={{ backgroundColor: "#e3f2fd", minHeight: '15vh' }}>
        <Footbar />
      </Box>
    </Router>
  );
}

/*
import { ThemeProvider, THEME_ID, createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
    },
    error: {
      light: '#ef5350',
      main: '#d32f2f',
      dark: '#c62828',
    },
    warning: {
      light: '#ff9800',
      main: '#ed6c02',
      dark: '#e65100',
    },
    info: {
      light: '#03a9f4',
      main: '#0288d1',
      dark: '#01579b',
    },
    success: {
      light: '#4caf50',
      main: '#2e7d32',
      dark: '#1b5e20',
    }
  },
});

<ThemeProvider theme={{ [THEME_ID]: theme }}>
</ThemeProvider>
*/